<template>
  <div ref="dialogRoot" class="text-mode-empty-state" role="dialog" aria-modal="true" aria-labelledby="text-mode-empty-state__title">
    <div class="text-mode-empty-state__backdrop" />
    <section class="text-mode-empty-state__dialog">
      <p id="text-mode-empty-state__title" class="text-mode-empty-state__message">
        {{ $t(messageConfig.messageToken) }}
      </p>
      <div class="text-mode-empty-state__actions">
        <button
            v-if="showContinue"
            type="button"
            data-analytics-skip
            class="text-mode-empty-state__continue"
            @click="$emit('continue')"
        >
          {{ $t('app.dialog.button.continue') }}
        </button>
        <button
            type="button"
            data-analytics-skip
            class="text-mode-empty-state__back"
            @click="$emit('back')"
        >
          {{ $t('app.assessment_mode.coming_soon.back') }}
        </button>
      </div>
    </section>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, ref } from 'vue';
import { type TextModeAlertType, useAlertStore } from '../stores/alert.store';
import { useDialogFocusTrap } from '@/composables/useDialogFocusTrap';

interface MessageConfig {
  messageToken: string;
}

const ALERT_MESSAGES: Record<TextModeAlertType, MessageConfig> = {
  no_focused_logic: {
    messageToken: 'app.assessment_mode.text.alert.no_focus_question',
  },
  comprehensive: {
    messageToken: 'app.assessment_mode.text.alert.comprehensive',
  },
  not_clinical: {
    messageToken: 'app.assessment_mode.text.alert.not_clinical',
  },
};

export default defineComponent({
  name: 'EvaluationErrorState',
  emits: ['back', 'continue'],

  setup() {
    const alertStore = useAlertStore();

    const messageConfig = computed<MessageConfig>(() => {
      if (alertStore.activeAlertType) return ALERT_MESSAGES[alertStore.activeAlertType];

      // This state should not be reachable.
      throw new Error('EvaluationErrorState rendered without any alert flag set');
    });
    const showContinue = computed(() => alertStore.activeAlertType === 'no_focused_logic');

    const dialogRoot = ref<HTMLElement | null>(null);
    useDialogFocusTrap(dialogRoot);

    return { messageConfig, showContinue, dialogRoot };
  },
});
</script>
